import ReactionContentAPI from '@/app/apis/main/content-reaction/content-reaction-api.js';

export default {
	/**
	 * @param {*} reactionDetails
	 * @returns {Promise}
	 */
	async saveReaction(reactionDetails) {
		return ReactionContentAPI.saveReaction(reactionDetails);
	},
	/**
	 * @param {*} reactionDetails
	 * @returns {Promise}
	 */
	async getReaction(reactionDetails) {
		return ReactionContentAPI.getReaction(reactionDetails);
	},
}